import ZkSysDictSaveOrUpdate from './src/main'
ZkSysDictSaveOrUpdate.install = function (Vue) {
  Vue.component(ZkSysDictSaveOrUpdate.name, ZkSysDictSaveOrUpdate)
}
export default ZkSysDictSaveOrUpdate



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/systemDictSaveOrUpdate/index.js